import { render } from "./OrdersTable.vue?vue&type=template&id=3a44b3af"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tel/jcr/ungerboeck_tables/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__